module.exports = __webpack_public_path__ + "img/g.7b0a5fc9.jpg";